import { render, staticRenderFns } from "./WhyChooseUS.vue?vue&type=template&id=4a27c8a0&scoped=true"
import script from "./WhyChooseUS.vue?vue&type=script&lang=ts"
export * from "./WhyChooseUS.vue?vue&type=script&lang=ts"
import style0 from "./WhyChooseUS.vue?vue&type=style&index=0&id=4a27c8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a27c8a0",
  null
  
)

export default component.exports